<template>
  <st-scrolly class="header-scrolly" :dontUseSticky="false">
    <template v-slot:background="{slideIndex, enter}">
      <div class="scrolly-content" v-if="header.scrolly">
        <component v-for="(slide,i) in header.scrolly" :key="i" :is="slide.type.toLowerCase()" :attributes="slide.value" :index="slideIndex" :enter="enter" :style="getImageStyle(i + 1, enter)"></component>
      </div>
    </template>

    <div :class="['slide',{'header-slide':(slide.value.content === 'header')}]" :style="slideStyle(i)" v-for="(slide, i) in header.scrolly" :key="i">
      <div class="slide-content main-headline-head-wrapper main-headline-content-wrapper">
        <div class="main-headline-head" v-if="slide.value.content === 'header'">
          <div class="main-headline">
            <div v-if="isPremium" class="premium-label">FOR SUBSCRIBERS</div>
            <h1 itemprop="headline" v-markdown="header.headline" :style="textStyle"></h1>
          </div>
          <div class="main-headline-content">
            <div itemprop="description" class="st-deck" :style="textStyle">
              <p v-for="(pitem, i) in header.deck" v-markdown="pitem" :key="i"></p>
            </div>
            <div class="st-byline" :style="textStyle">
              <time itemprop="datePublished" :datetime="header.datetime" :data-timestamp="timestamp"
                v-markdown="header.byline"></time>
            </div>
          </div>
          <scroll-down />
        </div>
        <p v-else v-markdown="slide.value.content"></p>
      </div>
    </div>

  </st-scrolly>
</template>

<script>
// https://github.com/yongjun21/st-scrolly/blob/master/packages/%40st-graphics/scrolly/src/index.vue
import StScrolly from '@st-graphics/scrolly'
import '@st-graphics/scrolly/dist/bundle.css'

import videoslide from './ScrollyVideo.vue'
import imageslide from './ScrollyImage.vue'
import ScrollDown from './scroll-down.vue'

export default {
  props: ['header'],
  components: {
    StScrolly,
    videoslide,
    imageslide,
    ScrollDown
  },
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  computed: {
    slideHeight () {
      return this.initHeight < 800 ? 800 : this.initHeight
    },
    isPremium () {
      return process.env.IS_PREMIUM
    },
    timestamp () {
      return new Date(this.header.datetime).getTime()
    },
    textStyle () {
      const {textwidth} = this.header
      return {
        maxWidth: textwidth || null
      }
    }
  },
  methods: {
    getImageStyle (index, enter) {
      return {
        opacity: index === 1 ? 1 : enter(index - 1, 200)
      }
    },
    slideStyle (i) {
      const isFirst = i === 0
      const isLast = i === this.header.scrolly.length - 1
      
      return {
        backgroundImage: this.header.bg && isFirst ? `linear-gradient(to bottom, ${this.header.bg} 5%, transparent)` : '',
        paddingTop: `${this.slideHeight}px`,
        paddingBottom: isLast ? `${this.slideHeight}px` : 0
      }
    }
  }
}
</script>

<style lang="scss">
.st-scrolly.header-scrolly {
  .background-container {
    .background,
    .foreground {
      & > * {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: auto;
        width: 100%;
        height: 100%;
      }
    }
  }

  .slide-container {
    @include container;
    max-width: 100%;
    .slide {
      @include container;
      position: relative;
      .slide-content {
        position: absolute;
        width: calc(100% - 32px);
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        background-color: #FFFFFF;
        max-width: 400px;
        margin: 0 $outerSpacingMobile;
        padding: 0;

        @include breakpoint($d_medium) {
          margin: 0 $outerSpacing;
          left: 16px;
        }

        img {
          display: block;
          width: 100%;
        }

        p {
          line-height: 30px;
          color: $black;
        }
      }
      &.header-slide {
        max-width: 100%;
        text-align: center;
        .slide-content {
          background-color: transparent;
          margin: 0;
          left: 50%;
          transform: translate(-50%, -50%);
          max-width: 700px;
          .main-headline {
            // padding-bottom: 20px;
          }
          .main-headline-head,
          p {
            padding-left: 0;
            padding-right: 0;
            line-height: 28px;
            &:first-child {
              padding-top: 0;
            }
            @include breakpoint($d_medium) {
              line-height: 30px;
            }
          }
          .st-byline {
            a {
              display: inline-block;
              margin-bottom: 2px;
            }
          }
          * {
            color: #FFFFFF;
            text-align: center;
          }
          .scroll_down {
            position: relative;
            bottom: 0;
            margin-top: 20px;
          }
        }
      }
      &:last-child {
        .slide-content {
          top: 25%;
          transform: translateY(-25%);
        }
      }
    }
  }
}
</style>
